<scaffold-dialog [size]="size">
  <div scaffoldDialogBody>
    <div *ngIf="opmPartners && opmPartners.length > 0 && !parent">

        <p-select ngDefaultControl [options]="opmPartnersOptions" [(ngModel)]="partnerId" optionLabel="name"
        optionValue="id" [placeholder]="'partner'| translation" (onChange)="getNewView()"/>

    </div>
    <app-view *ngIf="create" [info]="create" [items]="create?.data?.content" [data]="create_data"></app-view>
  </div>
  <div scaffoldDialogButtons>    
    <button pButton severity="secondary" (click)="dialogRef.close()">{{'close'| translation}}</button>   
    <button *ngIf="activeTab===0" pButton severity="primary" (click)="createData(data.type)" [disabled]="hasErrors()?.length > 0 || saving ||created || !create?.type">{{data.translation_key_label||data.label || 'add'| translation|translationFromString | transformText :data?.text_transform_label}}</button>
    <button *ngIf="activeTab===1" pButton severity="primary" (click)="linkData(import)" [disabled]="!import">{{'link'| translation}}</button>

  </div>
</scaffold-dialog>
